import { BrowserRouter as Router } from 'react-router-dom';
import { useEffect, useContext } from 'react';
import UserContext from './context/UserContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Routes from './routes/index';
import Download from './components/Download';

const App = () => {
  const { user, setUser } = useContext(UserContext);

  useEffect(() => {
    // should remove
    // setUser({id: 'sdfa6556'});
    
    const fetcher = async () => {
      try {
        const configRes = await fetch('/api');

        const configData = await configRes.json();

        sessionStorage.setItem('maxOrder', configData.maxCartSelectable)
        sessionStorage.setItem('minPrice', configData.minOrderPrice)

        const res = await fetch('/api/user', {
          method: 'GET',
          credentials: 'include',
          headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
              .content,
          },
        });

        const data = await res.json();
        setUser({data: data, config: configData });
      } catch (error) {
        // console.log(error);
      }
    };

    fetcher();
  }, [setUser]);

  return (
    <Router>
      <div className='App w-full h-fit min-h-screen flex flex-col justify-start items-center bg-blue-200'>
          <Download />
          <Header userData={user} />
          <Routes />
          <Footer />
      </div>
    </Router>
  );
};

export default App;
